<template>
  <div id="header_left_section" class="flex items-center justify-center gap-4">
    <BackButton
      v-if="!isOnLinkedEntityPage"
      use-route-only
      size="7"
      variant="variant3"
      :route="backButtonRoute"
      source="autoplay_tasks"
      :show-text="false"
    />

    <div
      class="flex items-center justify-center gap-[6px] h-10 p-1.5 pe-3 rounded-3xl border_bottom border_top border_left border_right"
    >
      <ProfileIcon :data="taskLinkedEntityDetails" />
      <span class="text-white font-normal text-base leading-[19px]">{{
        entityName
      }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-white/60 font-semibold text-sm leading-[17px]"
        >Task Name</span
      >
      <span class="text-white font-semibold text-base leading-[19px]">{{
        taskTitle
      }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";
import { useRoute } from "vue-router";
import { renderEntity } from "@/src/utils/utils.js";
import BackButton from "@/src/components/BackButton.vue";
import ProfileIcon from "@/src/components/ProfileIcon.vue";

const route = useRoute();
const store = inject("store");

const taskLinkedEntity = computed(
  () => store.getters["tasks/taskLinkedEntity"],
);
const taskLinkedEntityDetails = computed(
  () => store.getters["tasks/taskLinkedEntityDetails"],
);
const currentAutoplayTask = computed(
  () => store.getters["tasks/currentAutoPlayTask"],
);

// Handle both string and object formats for task title (CRM tasks have { value: "..." })
const taskTitle = computed(() => {
  const title = currentAutoplayTask.value?.task?.title;
  if (!title) return "";
  // CRM task format: { value: "..." }
  if (typeof title === "object" && title.value !== undefined) {
    return title.value;
  }
  // Legacy format: string
  return title;
});

const isOnLinkedEntityPage = computed(() => {
  try {
    if (!taskLinkedEntity.value || !route.path) return false;
    const { id, route: entityRoute } = taskLinkedEntity.value;
    return route.path.includes(entityRoute) && route.path.includes(`/${id}`);
  } catch (error) {
    console.error("Error checking if on linked entity page:", error);
    return false;
  }
});

const entityName = computed(() => {
  try {
    return renderEntity(taskLinkedEntityDetails.value);
  } catch (error) {
    console.error("Error getting entity name:", error);
    return "";
  }
});

const backButtonRoute = computed(() => {
  try {
    if (!taskLinkedEntity.value) {
      return "";
    }

    const { id, route } = taskLinkedEntity.value;
    return `${route}/${id}`;
  } catch (error) {
    console.error("Error getting back button route:", error);
    return "";
  }
});

</script>
